import * as Globals from '../../app/components/planboard/utils/globals';
import { isDictionary } from '../../app/components/utils/dictionary';

const CLICKABLE_ITEM_INDEX_LIMIT = -Globals.maxInt + 6; // items with an id lower than this are clickable, e.g. filter pallete redirect option

enum DropdownTriggerSource {
    ArrowClick = 'arrowClick',
    CharacterSearch = 'characterSearch'
}

export var omrpDropdownTree = [
    "$rootScope", "$timeout",
    function ($rootScope, $timeout) {
        return {
            // can be used as an attribute or element or class
            restrict: "AEC",

            //template: require("../template/dropdownTree.html"),
            template: function (elem, attrs) {
                if (attrs.activityType) {
                    //console.log("omrpDropdownTree alternate templateUrl:", attrs.templateUrl);
                    return require("../template/dropdownActivityTypes.html");
                }
                return require("../template/dropdownTree.html");
            },

            transclude: true,

            scope: {
                autosizewidth: "=",
                autosizeheight: "=",
                customwidthpx: "=",
                customheightpx: "=",
                customdropdownbtn: "@", // true to hide the default dropdown box, the custom contents inside the directive will be transcluded
                selchanged: "&?",
                changedisabled: "=",
                allitems: "=",
                itemsversion: "=", // when this variable changes the dropdowntree will rebuild the item tree
                noselectionid: "=", // the id of the item that indicates no selection
                selectedid: "=",
                showspinner: "=",
                ondropdown: "&?", // callback function to call after the datepicker dropdown is shown or hidden with visible as parameter 
                getdefaulttext: "&?", // callback function to call for the currently selected item, if the item does not exist in allitems
                getallitems: "&?", // callback function the get all items trough a function instead of the bound allitems property
                displayproperty: "@",
                enabledproperty: "@",
                filteronsearchproperty: "@", // property on which to filter when using character search
                visibleproperty: "@",
                activityType: "@?",
                addmode: "=?", //Add mode activitated
                addmodeclicked: "&?",
                addmodebuttonvisible: "=?",
                charactersearch: "="
            },

            link: function (scope, element) {
                scope.triggerElement = element[0];
                scope.dropdownVisible = false;
                scope.dropdownLeft = "0px";
                scope.dropdownTop = "0px";
                scope.dropdownWidth = "250px";
                scope.dropdownHeight = "200px";
                scope.dropdownvisibility = "visible";
                scope.visibleidlist = [];
                scope.newVisibleidlist = [];
                scope.clickableList = [];
                scope.firstitemid = null;
                scope.dict = null;
                scope.lastDictVersion = -1;
                scope.lastGetItem = null;
                scope.tree = Object.create(null);
                scope.dropDownClicked = false; // indicates that the tree has been dropped down at least once
                scope.highlightedItemIndex = -1;
                scope.textfilter = null;
                scope.oldtextfilter = null;
                scope.lastDropdownTriggerSource = null;

                var itemHeight = 0; // height of an item element

                scope.triggerDropdownChanged = function () {
                    if (scope.ondropdown != undefined)
                        scope.ondropdown({ visible: scope.dropdownVisible }); 
                }

                // set internal scope.dict variable to either scope.allitems or the dictionary object in scope.allitems, return true if it is not undefined
                scope.initializeDict = function () {
                    var items = scope.allitems;
                    if (scope.getallitems != undefined && scope.dropDownClicked)
                        items = scope.getallitems();
                    if (isDictionary(items)) { // dictionary
                        scope.dict = items.getStore();
                        scope.lastDictVersion = items.version;
                    } else // object
                        scope.dict = items;
                    return (scope.dict != undefined);
                }

                // recreate the items dropdowntree
                scope.refreshItems = function () {
                    scope.lastGetItem = null;
                    scope.firstitemid = null;

                    // Prevent user input loss on dropdown refresh
                    const isCharacterSearch =
                      scope.dropdownVisible &&
                      scope.lastDropdownTriggerSource ===
                        DropdownTriggerSource.CharacterSearch;

                    if (!isCharacterSearch) {
                        const selectedText = scope.getItemText(scope.selectedid);
                        scope.textfilter = selectedText;
                        scope.oldtextfilter = selectedText;
                    }
                   
                    scope.initializeDict();

                    if (scope.dropdownVisible) {
                        scope.sanitizeAllItems();
                        scope.buildVisibleList(scope.firstitemid);
                        scope.visibleidlist = scope.newVisibleidlist;
                        scope.setItemHighlighted(calculateItemIndexToHighlight())
                        scope.repositionDropdown();
                        
                        // Set the highlightedItemIndex to the currently selected item, or -1
                        $timeout(function () {
                            scrollIfNeeded(scope.highlightedItemIndex, "UP");
                        }, 0);
                    }
                }

                // recreate the items dropdowntree if version changes
                scope.$watch("itemsversion", function (value) { scope.refreshItems(); });

                // recreate the items dropdowntree if allitems changes
                scope.$watch("allitems", function (value) { scope.refreshItems(); });

                scope.$watch("textfilter", function () {
                    if (scope.textfilter !== "" && !scope.dropdownVisible && scope.textfilter !== scope.oldtextfilter) {
                        scope.show(DropdownTriggerSource.CharacterSearch);
                    }

                    if (scope.textfilter !== scope.oldtextfilter) {
                        scope.oldtextfilter = "";
                    }

                    scope.buildVisibleList(scope.firstitemid);
                    scope.visibleidlist = scope.newVisibleidlist;
                    scope.setItemHighlighted(scope.newVisibleidlist.findIndex(scope.getItemEnabled))
                    scope.repositionDropdown();
                });

                // computes the nextId and childId properties of items in scope.allitems
                scope.sanitizeAllItems = function () {
                    scope.firstitemid = null;
                    scope.lastGetItem = null;
                    if (!scope.initializeDict()) return;
                    var lastRootId = null;
                    var key = -1;
                    var index = -1;
                    var item = null;
                    var treeItem = null;
                    var orderedItems = [];
                    scope.tree = Object.create(null);
                    for (<any>key in scope.dict) {
                        if (scope.dict.hasOwnProperty == undefined || scope.dict.hasOwnProperty(key)) {
                            item = scope.dict[key];
                            treeItem = {
                                nextId: null,
                                childId: null,
                                lastChildId: null,
                                open: item.open == undefined ? false : item.open,
                                parentId: item.parentId,
                                order: item.order || item.receivedOrder || 0
                            };
                            scope.tree[key] = treeItem;
                            // remember and sort based upon the items order property
                            orderedItems.push(key);
                            index = orderedItems.length - 1;
                            while (index > 0 && treeItem.order < scope.tree[orderedItems[index - 1]].order) {
                                orderedItems[index] = orderedItems[index - 1];
                                orderedItems[index - 1] = key;
                                index--;
                            }
                        }
                    }
                    for (var i = 0; i < orderedItems.length; i++) {
                        key = orderedItems[i];
                        item = scope.tree[key];
                        if (!item.parentId || item.parentId < 0 || !scope.tree[item.parentId]) {
                            if (scope.firstitemid == null) scope.firstitemid = key;
                            if (lastRootId != null) scope.tree[lastRootId].nextId = key;
                            lastRootId = key;
                        }
                        if (item.parentId && scope.tree[item.parentId]) {
                            var parent = scope.tree[item.parentId];
                            if (parent.lastChildId)
                                scope.tree[parent.lastChildId].nextId = key;
                            else
                                parent.childId = key;
                            parent.lastChildId = key;
                        }
                    }
                }

                // build an array of all visible items, based upon the open state of each item
                scope.buildVisibleList = function (itemid) {
                    if (scope.firstitemid == null || itemid === scope.firstitemid) {
                        scope.newVisibleidlist = [];
                        scope.clickableList = [];
                    } 
                    if (!scope.initializeDict()) return;
                    var item = scope.tree[itemid];

                    while (item != undefined) {
                        if (scope.charactersearch) {
                            const filter = scope.textfilter?.trim().toLowerCase() ?? "";

                            // Prevent filtering disabled nodes since they're used as parent nodes for grouping.
                            if (
                                filter === "" ||
                                scope.textfilter === scope.oldtextfilter ||
                                scope.getItemText(itemid).trim().toLowerCase().indexOf(filter) >= 0 ||
                                !scope.getItemFilterOnSearchProperty(itemid)
                            ) {
                                scope.newVisibleidlist.push(itemid);

                                if (item.open && item.childId) {
                                    scope.buildVisibleList(item.childId);
                                }
                            }
                        } else {
                            if (itemid < CLICKABLE_ITEM_INDEX_LIMIT) {
                                scope.clickableList.push(itemid);
                            } else {
                                scope.newVisibleidlist.push(itemid);
                            }

                            if (item.open && item.childId)
                                scope.buildVisibleList(item.childId);
                        }

                        if (item.nextId) {
                            itemid = item.nextId;
                            item = scope.tree[itemid];
                        } else
                            item = undefined;
                    }
                }

                scope.makeItemVisible = function (itemid) {
                    if (!scope.initializeDict()) return;
                    var item = scope.tree[itemid];
                    while (item) {
                        item.open = true;
                        item = scope.tree[item.parentId];
                    }
                }

                scope.toggleItemOpen = function (itemid) {
                    if (scope.noselectionid && parseInt(itemid) == parseInt(scope.noselectionid)) {
                        scope.selectItem(itemid);
                        return;
                    }
                    if (!scope.initializeDict()) return;
                    var item = scope.tree[itemid];
                    if (item && item.childId && scope.tree[item.childId]) {
                        item.open = !item.open;
                        scope.buildVisibleList(scope.firstitemid);
                        scope.visibleidlist = scope.newVisibleidlist;
                        scope.repositionDropdown();
                    }
                }

                scope.selectItem = function (itemid) {
                    if (!scope.initializeDict()) return;
                    // Future TODO: item could have an id higher than maxInt. Consider a different solution
                    if (itemid >= Globals.maxInt) return;// Return if itemId is a section header (e.g. Activity, Daymark)
                    scope.selectedid = parseInt(itemid);
                    scope.oldtextfilter = scope.getItemText(scope.selectedid)
                    scope.textfilter = scope.getItemText(scope.selectedid);
                    if (scope.selchanged != undefined) scope.selchanged({ itemId: scope.selectedid });
                    scope.dropdownVisible = false;
                    // stop listening for keyboard input / re-enable scroll
                    window.removeEventListener("keydown", keyboardInputHandler, false);
                    if (scope.selectedid > 0) {
                        scope.addmode = true;
                    } else {
                        scope.addmode = false;
                    }
                    scope.triggerDropdownChanged();
                }

                scope.getItemOrNull = function (itemid) {
                    if (scope.lastGetItem && scope.lastGetItem.id === itemid) return scope.lastGetItem;
                    scope.lastGetItem = scope.initializeDict() ? scope.dict[itemid] : null;
                    return scope.lastGetItem;
                }

                scope.getItem = function (itemid) {
                    scope.getItemOrNull(itemid);
                    if (!scope.lastGetItem) scope.lastGetItem = {};
                    return scope.lastGetItem;
                }

                scope.getItemEnabled = function (itemid) {
                    var item = scope.getItemOrNull(itemid);
                    if (!item) return false;
                    if (scope.enabledproperty && scope.enabledproperty !== "")
                        if (item[scope.enabledproperty] != undefined) return item[scope.enabledproperty];
                    if (item.enabled != undefined) return item.enabled;
                    return true;
                }

                // Returns if the item is highlighted (for formatting)
                scope.getItemHighlighted = function (itemIndex) {
                    if (itemIndex === scope.highlightedItemIndex)
                        return true;
                    return false;
                }

                // Sets scope.highlightedItemIndex to the provided itemIndex (used for mouse over highlighting)
                scope.setItemHighlighted = function (itemIndex) {
                    $timeout(function () {
                        scope.highlightedItemIndex = itemIndex;
                    }, 0);
                }

                // Get the id of the html element or give the html element an unique id if it has none
                scope.getTriggerElementId = function () {
                    if (scope.triggerElement.id === "") scope.triggerElement.id = "genId" + Math.floor(Math.random() * Globals.maxInt53);
                    return scope.triggerElement.id;
                }

                scope.getItemVisible = function (itemid) {
                    var item = scope.getItemOrNull(itemid);
                    if (!item) return false;
                    if (scope.visibleproperty && scope.visibleproperty !== "")
                        if (item[scope.visibleproperty] !== undefined) return item[scope.visibleproperty];
                    return true;
                }

                scope.getItemFilterOnSearchProperty = function (itemid) {
                    var item = scope.getItemOrNull(itemid);

                    if (!item) {
                        return false;
                    }

                    if (
                        scope.filteronsearchproperty &&
                        scope.filteronsearchproperty !== "" &&
                        item[scope.filteronsearchproperty] !== null &&
                        item[scope.filteronsearchproperty] !== undefined 
                    ) {
                      return item[scope.filteronsearchproperty];
                    }

                    return true;
                }

                scope.getItemOpen = function (itemid) {
                    var item = scope.tree[itemid];
                    return (item && item.open && item.childId && scope.tree[item.childId]);
                }

                scope.getItemIsLeaf = function (itemid) {
                    var item = scope.tree[itemid];
                    return (item && (!item.childId || !scope.tree[item.childId]));
                }

                scope.getItemHasParent = function (itemid) {
                    var item = scope.tree[itemid];
                    return (item && item.parentId && item.parentId >= 0);
                }

                scope.getItemIndent = function (itemid) {
                    var indent = 0;
                    var item = scope.tree[itemid];
                    while (item && indent < 20) {
                        if (!item.childId || !scope.tree[item.childId]) indent--;
                        item = scope.tree[item.parentId];
                        if (item) indent++;
                    }
                    if (indent < 0) indent = 0;
                    return "" + indent + "em";
                }

                scope.getItemColor = function (itemid) {
                    var item = scope.getItemOrNull(itemid); // Get the item by its id
                    if (item && item.isActive === true) {
                        return '#F07000'; // Apply the color when isActive is true
                    } else {
                        return ''; // Don't apply any specific color otherwise
                    }
                };

                scope.getItemText = function (itemid) {
                    var item = scope.getItemOrNull(itemid);
                    if (!item) {
                        if (scope.getdefaulttext != undefined)
                            return scope.getdefaulttext({ id: itemid });
                        return "";
                    }
                    if (scope.displayproperty && scope.displayproperty !== "")
                        return item[scope.displayproperty];
                    return item.text;
                }

                scope.pxToInt = function (pxvalue) {
                    return parseInt(pxvalue.substring(0, pxvalue.length - 2));
                }

                scope.repositionDropdown = function () {
                    $timeout(function () {
                        if (!scope.dropdownVisible) return;
                        if (!scope.dropdownElement) return;
                        if (!scope.displayElement) return;

                        var rectDropdown = scope.dropdownElement.getBoundingClientRect();
                        var rect = scope.displayElement.getBoundingClientRect();
                        var leftPos = rect.left;
                        var topPos = rect.bottom - 1;
                        if (topPos + rectDropdown.height >= window.innerHeight) {
                            topPos = Math.max(rect.top - rectDropdown.height, 0);
                        }
                        if (scope.autosizewidth) {
                            // make the dropdownElement just as wide as the triggerElement
                            scope.dropdownWidth = "" + rect.width + "px";
                        }
                        if (leftPos + scope.pxToInt(scope.dropdownWidth) >= window.innerWidth) {
                            leftPos = Math.max(window.innerWidth - scope.pxToInt(scope.dropdownWidth), 0);
                        }
                        leftPos = Math.round(leftPos + window.pageXOffset);
                        topPos = Math.round(topPos + window.pageYOffset);
                        scope.dropdownLeft = "" + leftPos + "px";
                        scope.dropdownTop = "" + topPos + "px";
                        scope.dropdownvisibility = "visible";
                    }, 1);
                }

                scope.switchToAddingMode = function () {
                    if (scope.selectedid > 0) {
                        scope.addmode = true;
                        if (scope.addmodeclicked != undefined) scope.addmodeclicked({ addModeValue: scope.addmode });
                    } else {
                        scope.selectItem(-Globals.maxInt + 1);
                    }
                }

                scope.switchToPassiveMode = function () {
                    if (scope.selectedid > 0) {
                        scope.addmode = false;
                        if (scope.addmodeclicked != undefined) scope.addmodeclicked({ addModeValue: scope.addmode });
                    }
                }

                scope.clear = function () {
                    scope.selectItem(-Globals.maxInt + 1);
                }

                scope.show = function (triggerSource: DropdownTriggerSource = DropdownTriggerSource.ArrowClick) {
                    scope.lastDropdownTriggerSource = triggerSource;

                    if (scope.changedisabled) return;
                    if (!scope.dropdownElement) {
                        // find the dropdown-list and move it to the end of the document body
                        // this is neccesary so it wont be restricted by a parents bounding div element
                        // scope.triggerElement = the element triggering this directive
                        // scope.triggerElement.firstElementChild = "dropdown-container" element
                        // scope.triggerElement.firstElementChild.firstElementChild = "dropdown-display" element
                        // scope.triggerElement.firstElementChild.lastElementChild = "dropdown-list" element
                        scope.displayElement = scope.triggerElement.firstElementChild.firstElementChild;
                        scope.dropdownElement = scope.triggerElement.firstElementChild.lastElementChild;
                        scope.dropdownElement = document.body.appendChild(scope.dropdownElement);
                    }

                    // Listen for keyboard input
                    window.addEventListener("keydown", keyboardInputHandler, false);


                    scope.dropDownClicked = true;
                    // initialize, if either sanitizeAllItems has not been called before (firstitemid == null) or always if getallitems callback function is specified
                    if (scope.firstitemid == null || scope.getallitems != undefined)
                        scope.sanitizeAllItems();
                    else if (isDictionary(scope.allitems) && scope.lastDictVersion !== scope.allitems.version) {
                        // dictionary has different version
                        scope.sanitizeAllItems();
                    }

                    scope.makeItemVisible(scope.selectedid);
                    scope.buildVisibleList(scope.firstitemid);
                    scope.visibleidlist = scope.newVisibleidlist;
                    scope.setItemHighlighted(calculateItemIndexToHighlight());

                    // Set the highlightedItemIndex to the currently selected item, or -1
                    $timeout(function () {
                        scrollIfNeeded(scope.highlightedItemIndex, "UP");
                    }, 0);

                    if (scope.customwidthpx) scope.dropdownWidth = "" + scope.customwidthpx + "px";
                    if (scope.customheightpx) scope.dropdownHeight = "" + scope.customheightpx + "px";

                    // position the dropdownElement near triggerElement
                    var rect = scope.displayElement.getBoundingClientRect();
                    var leftPos = rect.left;
                    var topPos = rect.bottom - 1;
                    if (topPos + scope.pxToInt(scope.dropdownHeight) >= window.innerHeight) {
                        topPos = Math.max(rect.top - scope.pxToInt(scope.dropdownHeight), 0);
                        scope.dropdownvisibility = "hidden";
                    }
                    if (scope.autosizewidth) {
                        // make the dropdownElement just as wide as the triggerElement
                        scope.dropdownWidth = "" + rect.width + "px";
                    }
                    if (leftPos + scope.pxToInt(scope.dropdownWidth) >= window.innerWidth) {
                        leftPos = Math.max(window.innerWidth - scope.pxToInt(scope.dropdownWidth), 0);
                    }
                    leftPos = Math.round(leftPos + window.pageXOffset);
                    topPos = Math.round(topPos + window.pageYOffset);
                    scope.dropdownLeft = "" + leftPos + "px";
                    scope.dropdownTop = "" + topPos + "px";

                    // toggle visibility of the dropdownElement
                    scope.dropdownVisible = !scope.dropdownVisible;
                    if (!scope.dropdownVisible) {
                        // stop listening for keyboard input / re-enable scroll
                        window.removeEventListener("keydown", keyboardInputHandler, false);
                    }
                    scope.triggerDropdownChanged();
                    scope.repositionDropdown();
                };

                function calculateItemIndexToHighlight() {
                    return scope.selectedid > 0
                        ? scope.visibleidlist.indexOf(String(scope.selectedid))
                        : scope.visibleidlist.findIndex(scope.getItemEnabled);
                }

                // Event handler for Keyboard input
                // Arrow keys, Tab, Enter, Escape
                function keyboardInputHandler(e) {
                    // event.keyCode is deprecated. If it doesn't exist, use event.key.
                    var keyCode = e.keyCode;
                    if (keyCode === undefined || keyCode === 0)
                        keyCode = e.key;

                    // handle keys
                    switch (keyCode) {
                        case 9:
                        case "Tab":
                            e.preventDefault();
                            onTabKeyPress();
                            break;
                        case 13:
                        case "Enter":
                            e.preventDefault();
                            onEnterKeyPress();
                            break;
                        case 27:
                        case "Escape":
                        case "Esc":
                            e.preventDefault();
                            onEscapeKeyPress();
                            break;
                        case 37:
                        case "ArrowLeft":
                        case "Left":
                            onArrowLeftKeyPress();
                            break;
                        case 38:
                        case "ArrowUp":
                        case "Up":
                            e.preventDefault();
                            onArrowUpKeyPress();
                            break;
                        case 39:
                        case "ArrowRight":
                        case "Right":
                            onArrowRightKeyPress();
                            break;
                        case 40:
                        case "ArrowDown":
                        case "Down":
                            e.preventDefault();
                            onArrowDownKeyPress();
                            break;
                        default:
                            break;
                    }
                }

                // Handle Up Arrow key press
                // Allows user to navigate up through the dropdown items
                function onArrowUpKeyPress() {
                    let indexToBeHighlighted = scope.highlightedItemIndex - 1;

                    while ( indexToBeHighlighted > 0 && !scope.getItemEnabled(scope.visibleidlist[indexToBeHighlighted])) {
                        indexToBeHighlighted--;
                    }
                
                    if (scope.highlightedItemIndex !== indexToBeHighlighted && indexToBeHighlighted >= 0 && scope.getItemEnabled(scope.visibleidlist[indexToBeHighlighted])) {
                        scope.setItemHighlighted(indexToBeHighlighted)
                    }

                    scrollIfNeeded(scope.highlightedItemIndex, "UP");
                }

                // Handle Down Arrow key press
                // Allows user to navigate down through the dropdown items
                function onArrowDownKeyPress() {
                    let itemIndexToBeHighlighted = scope.highlightedItemIndex + 1;

                    while ( itemIndexToBeHighlighted < scope.visibleidlist.length && !scope.getItemEnabled(scope.visibleidlist[itemIndexToBeHighlighted])) {
                        itemIndexToBeHighlighted++;
                    }

                    if (itemIndexToBeHighlighted < scope.visibleidlist.length && scope.getItemEnabled(scope.visibleidlist[itemIndexToBeHighlighted])) {
                        scope.setItemHighlighted(itemIndexToBeHighlighted);
                    }

                    scrollIfNeeded(itemIndexToBeHighlighted, "DOWN");
                }

                // Handle Enter key press
                // Selects the currently highlighted item and closes the dropdown
                function onEnterKeyPress() {
                    if (scope.highlightedItemIndex > -1 && scope.highlightedItemIndex < scope.visibleidlist.length) {
                        var itemId = scope.visibleidlist[scope.highlightedItemIndex];
                        scope.$apply(scope.selectItem(itemId));
                    }
                }

                // Handle Tab key press
                function onTabKeyPress() {
                    // Future TODO: handle tab key press?
                    // If they are using keyboard to scroll through dropdown, perhaps they're using tab to go to next form item
                    // Should this select the item and move to the next form element?
                    // Or perhaps simply close the dropdown without selecting and focus the next form element?
                }

                // Handle Escape key press
                // Closes the dropdown without changing the selection
                function onEscapeKeyPress() {
                    $timeout(function () {
                        scope.dropdownVisible = false;
                        // stop listening for keyboard input / re-enable scroll
                        window.removeEventListener("keydown", keyboardInputHandler, false);
                        scope.triggerDropdownChanged();
                    }, 0);
                }

                // Handle Left Arrow key press
                function onArrowLeftKeyPress() {
                    // Future TODO: collapse a tree node
                }

                // Handle Right Arrow key press
                function onArrowRightKeyPress() {
                    // Future TODO: expand a tree node
                }

                // Performs the provided scroll action if needed
                function scrollIfNeeded(itemIndex, scrollDirection) {
                    // Escape early if there is no overflow or if itemIndex is < 0
                    if (scope.dropdownElement.clientHeight >= scope.dropdownElement.scrollHeight || itemIndex < 0) return;
                    // Get an item element to calculate the height if it hasn't been calculated before
                    if (itemHeight <= 0) {
                        var firstItemElement = scope.dropdownElement.firstElementChild.firstElementChild;
                        itemHeight = firstItemElement.offsetHeight;
                    }
                    // Calculate the item top and bottom positions relative to the entire item list container
                    // +1 to account for the 1 pixel space between items (potentially due to a return character)
                    var itemTop = itemIndex * (itemHeight + 1);
                    var itemBottom = itemTop + itemHeight;

                    // Calculate the approximate height of the dropdown.
                    // Removing 2X the vertical padding gives us a height that is a bit smaller than the visible area
                    // When only removing 1X the vertical padding, the height was a bit bigger than the visible area which clipped the bottom highlighted item
                    var computedStyle = getComputedStyle(scope.dropdownElement);
                    var dropdownHeight = scope.dropdownElement.clientHeight -
                        2 * (parseFloat(computedStyle.paddingTop) + parseFloat(computedStyle.paddingBottom));

                    // Calculate the top and bottom positions of the visible view
                    var dropdownTop = scope.dropdownElement.scrollTop;
                    var dropdownBottom = dropdownTop + dropdownHeight;

                    if (itemTop < dropdownTop || itemBottom > dropdownBottom) {
                        if (scrollDirection === "UP")
                            scrollUpTo(itemTop);
                        else if (scrollDirection === "DOWN")
                            scrollDownTo(itemBottom, dropdownHeight);
                    }
                }

                // Set the scrollTop to the correct value so that the item will be at the top of the dropdown
                function scrollUpTo(itemTop) {
                    scope.dropdownElement.scrollTop = itemTop;
                }

                // Set the scrollTop to the correct value so that the item will be at the bottom of the dropdown
                function scrollDownTo(itemBottom, dropdownHeight) {
                    scope.dropdownElement.scrollTop = itemBottom - dropdownHeight;
                }

                scope.$on("$destroy", function () {
                    // if the dropdownElement was attached to the body, we also need to remove it when the scope is destroyed
                    if (scope.dropdownElement) document.body.removeChild(scope.dropdownElement);
                });

                $rootScope.$on("documentClicked", function (inner, target) {
                    if (!scope.dropdownVisible) return; // exit early if the dropdown is not visible
                    // check if the clicked on control has a specific class or has any parent with that specific class, then do not close the dropdown
                    var parents = $(target[0]).parents();
                    for (var i = 0; i < parents.length; i++)
                        if (parents[i] === scope.triggerElement) return;
                    if (!$(target[0]).is(".ignore-document-clicked") &&
                        !(<any>($(target[0]).parents(".ignore-document-clicked").length) > 0))
                        scope.$apply(function () {
                            scope.dropdownVisible = false;
                            // stop listening for keyboard input / re-enable scroll
                            window.removeEventListener("keydown", keyboardInputHandler, false);
                            scope.oldtextfilter = scope.getItemText(scope.selectedid)
                            scope.textfilter = scope.getItemText(scope.selectedid);
                            scope.triggerDropdownChanged();
                        });
                });
            }
        };
    }
];